<template>
  <div class="m-column">
    <a-tabs
      default-active-key="1"
      @change="checkCategory"
      :animated="false"
      size="large"
    >
      <a-tab-pane
        v-for="item in categoryList"
        :key="item.articleCategoryId"
        :tab="item.title"
      >
      </a-tab-pane>
    </a-tabs>
  </div>

  <!--<div class="m-pc-column" :style="{'background':categoryBox.backgroundColor.value}" >-->

  <!--<div-->
  <!--class="column-item"-->
  <!--v-for="item in categoryList"-->
  <!--:key="item.articleCategoryId"-->
  <!--:class="{ active: item.isActive, '': item.isActive == 0 }"-->
  <!--@click="checkCategory(item)"-->
  <!--&gt;-->
  <!--<span :style="{'color':category.color.value}">{{ item.title }}</span>-->
  <!--</div>-->
  <!--</div>-->
</template>
<script>
import { articleCategoryId, globalUserId, isSetting } from "../common/sbase";
import { columnData } from "../common/settingData";
import service from "../services/article";
import { $subscriber } from "fire-wind-water";

export default {
  name: "Column",
  data() {
    return {
      categoryList: [],
      title: "",
      category: {
        backgroundColor: {
          value: ""
        },
        color: {
          value: ""
        }
      },
      categoryBox: {
        backgroundColor: {
          value: ""
        }
      }
    };
  },
  created() {
    if (!isSetting) {
      this.getCategoryList();
    } else {
      this.categoryList = columnData;
      $subscriber.emit("get-actile-list", 1);
    }
    $subscriber.subscribe("config-loaded", res => {
      this.category = res.category;
      this.categoryBox = res.categoryBox;
    });
  },
  methods: {
    getCategoryList() {
      let param = {
        articleCategoryId: articleCategoryId,
        globalUserId: globalUserId
      };
      service.getSubList(param).subscribe(data => {
        this.categoryList = data.content.subCategories;
        $subscriber.emit("category-title", data.content.title); //获取到网页标题

        if (this.categoryList.length > 0) {
          this.categoryList[0].isActive = true;
          $subscriber.emit(
            "get-actile-list",
            this.categoryList[0].articleCategoryId
          );
        }
        $subscriber.emit("category-info", data.content);
      });
    },
    checkCategory(articleCategoryId) {
      //      debugger;
      //      item;
      //      this.categoryList.forEach(i => {
      //        i.isActive = false;
      //      });
      //      item.isActive = true;
      $subscriber.emit("get-actile-list", articleCategoryId);
      this.$forceUpdate(); //有坑 需要强制更新
      // $('.column-item').css('background',this.categoryBox.backgroundColor.value);
      // setTimeout(()=>{
      //   $('.m-pc-column>.active').css('background',this.category.backgroundColor.value);
      // },0);
    }
  },
  components: {}
};
</script>
